import { fetchSearchVacant } from 'promotions/store/searchVacant/actions';
import { parseSearchVacantQuery } from 'promotions/utils/searchVacantUtils';

import type { universalRouterProps } from 'promotions/core/universalRouter/types';
export default async ({ store: { dispatch } }: universalRouterProps, context: any) => {
  // const query = context?.query || {};
  // // Parse query parameters and convert to API format
  // const params = parseSearchVacantQuery(query);
  // await dispatch(fetchSearchVacant(params));
};
